import type { IssueMetadata } from '../types/issue';

/** Motivo obrigatório. Espaço em branco não conta. */
export function normalizeRequiredReason(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : null;
}

/** Grava o motivo sem mudar o status. O encerramento continua na transição. */
export function closureReasonPatch(
  metadata: IssueMetadata | null | undefined,
  reason: string,
): { metadata: IssueMetadata } | null {
  const normalized = normalizeRequiredReason(reason);
  if (!normalized) return null;
  return { metadata: { ...(metadata ?? {}), closure_reason: normalized } };
}
